"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M17 4c-.28 0-.53.11-.71.29L7 13.59 3.71 10.3A.965.965 0 003 10a1.003 1.003 0 00-.71 1.71l4 4c.18.18.43.29.71.29s.53-.11.71-.29l10-10A1.003 1.003 0 0017 4z"];
//# sourceMappingURL=tick.js.map